import { t } from '@web/i18n';
import { AppIcons } from '@web/ui/core';

export function McpChip(): React.JSX.Element {
  return (
    <span className="inline-flex h-5.5 items-center gap-1.5 rounded-pill bg-tone-green-tint px-2 text-micro font-medium text-tone-green-ink">
      <AppIcons name="lightning" size={11} />
      {t('members.chip.mcp')}
    </span>
  );
}
